module.exports = __webpack_public_path__ + "img/jubran_pharma.1e07fa5b.webp";